export default __webpack_public_path__ + "static/media/recycle-background.8c966fbb.jpg";